<template>
  <div class="container concerned-about-vaccination">
    <div class="row pt-2">
      <div class="col-12 offset-md-2 col-md-8">
        <vm-progress :percentage="60" :show-text="false" :stroke-width="12" :strokeColor="'#2bb1c4'"></vm-progress>
      </div>
    </div>
    <back-and-skip skip="preventativehealth">
    </back-and-skip>
    <div class="row pt-5 pt-lg-4">
      <div class="col-12 text-center">
        <img class="img-question" src="../assets/concerned_about_vaccination.svg" alt="concerned-about-vaccination">
      </div>
    </div>
    <div class="row row-title">
      <div class="col-12 offset-lg-2 col-lg-8 text-center text-wrap">
        <label class="title">
          {{ $t('concernedAboutVaccination.title') }}
        </label>
      </div>
    </div>
    <yes-no
      @yes="yes"
      @no="no">
    </yes-no>
  </div>
</template>

<script>
import BackAndSkip from '../components/BackAndSkip.vue'
import YesNo from '../components/YesNoButtons.vue'

export default {
  components: {
    BackAndSkip,
    YesNo
  },
  methods: {
    yes () {
      const answer = {
        key: 'concerned_about_vaccination_or_treatment',
        value: 'yes'
      }

      this.$store.commit('SET_DATA_SURVEY', answer)

      this.$router.push({
        name: 'whyconcerned'
      })
    },
    no () {
      const answer = {
        key: 'concerned_about_vaccination_or_treatment',
        value: 'no'
      }

      this.$store.commit('SET_DATA_SURVEY', answer)

      const answerWhyConcerned = {
        key: 'why_concerned',
        value: null
      }

      this.$store.commit('SET_DATA_SURVEY', answerWhyConcerned)

      this.$router.push({
        name: 'preventativehealth'
      })
    }
  },
  mounted () {
    this.$store.commit('SET_LAST_PAGE', 'concernedaboutvaccination')
  }
}
</script>

<style>
.concerned-about-vaccination .img-question {
  width: 100%;
  height: 27vh;
}

.concerned-about-vaccination .title {
  font-weight: 700;
  font-size: 1.4rem;
}

.concerned-about-vaccination .row-title {
  padding-top: 2rem;
  padding-bottom: 7rem;
}

@media screen and (device-aspect-ratio: 40/71) {
  .concerned-about-vaccination .img-question {
    height: 21vh;
  }

  .concerned-about-vaccination .title {
    font-size: 1.1rem;
  }

  .concerned-about-vaccination .row-title {
    padding-top: 2rem;
    padding-bottom: 2.8rem;
  }
}
</style>
